import { MyTaskApi } from "@/api/MyTaskApi";
import { DakokuDataFull, MyTaskData, MyTaskDakokuData, SoumuDakokuCheckListRes } from "@/types/Dakoku";
import { HakenSyouninListReq, ZangyouCheckListReq, ZangyouCheckListRes, HakensakiShimeCheckData } from "@/types/MyTask";
import { DakokuWhereConditions, SoumuDakokuCheckWhereConditions, SoumuDakokuCheckRequest } from "@/types/MyTask";

export class MyTaskService {

  /**
  * 承認打刻情報を取得します
  * @returns
  */
  public async getDakokuSyouninList(paramas: DakokuWhereConditions): Promise<MyTaskDakokuData[] | null> {

    const api = new MyTaskApi();
    try {
      return await api.getDakokuSyouninList(paramas);
    } catch (e) {
      return null;
    }
  }

  /**
  * 総務が確認する打刻情報を取得します
  * @returns
  */
  public async getDakokuSoumuCheckList(paramas: SoumuDakokuCheckWhereConditions): Promise<SoumuDakokuCheckListRes> {

    const api = new MyTaskApi();
    try {
      return await api.getDakokuSoumuCheckList(paramas);
    } catch (e) {
      return {'allList':[], 'totalDataCount':0};
    }
  }

  /**
   * 総務チェックを一括登録します。
   * @param params
   * @returns 登録件数
   */
  public async updateSoumuChecks(params: SoumuDakokuCheckRequest): Promise<MyTaskData[] | null> {
    const api = new MyTaskApi();
    try {
      return await api.updateSoumuChecks(params);
    } catch (e) {
      return null;
    }
  }

  /**
   * 承認チェックを一括登録します。
   * @param params
   * @returns 登録件数
   */
  public async updateSyouninChecks(params: number[]): Promise<DakokuDataFull[] | null> {
    const api = new MyTaskApi();
    try {
      return await api.updateSyouninChecks(params);
    } catch (e) {
      return null;
    }
  }

  /**
  * 派遣先上長が月締め承認する情報を取得します
  * @returns
  */
  public async getHakenSyouninList(paramas: HakenSyouninListReq): Promise<MyTaskData[] | null> {

    const api = new MyTaskApi();
    try {
      return await api.getHakenSyouninList(paramas);
    } catch (e) {
      return [];
    }
  }

  // 残業45時間以上のサマリを取得します
  public async getOver45Zangyou(req: ZangyouCheckListReq): Promise<ZangyouCheckListRes> {

    const api = new MyTaskApi();
    try {
      return await api.getOver45Zangyou(req);
    } catch (e: any) {
      console.log(e)
      throw e;
    }
  }

  /**
  * 総務が確認する派遣先上長月締め情報を取得します
  * @returns
  */
    public async getHakensakiShimeCheckList(paramas: HakenSyouninListReq): Promise<HakensakiShimeCheckData[] | null> {

      const api = new MyTaskApi();
      try {
        return await api.getHakensakiShimeCheckList(paramas);
      } catch (e) {
        return [];
      }
    }

}
